import { ConfigProvider, theme } from "antd";
import { useTranslation } from "react-i18next";
import zhTW from "antd/locale/zh_TW";
import enUS from "antd/locale/en_US";

import { AppConfigProvider } from "@/providers";
import App from "@/App";

export const AntdProvider = () => {
  const { i18n } = useTranslation();

  return (
    <ConfigProvider
      locale={i18n.language === "zh-TW" ? zhTW : enUS}
      theme={{
        algorithm: theme.compactAlgorithm,
        token: {
          fontSize: 16,
          fontWeightStrong: 500,
          fontFamily: `'Ubuntu Mono', 'Noto Sans TC', monospace, sans-serif`,
        },
      }}
    >
      <AppConfigProvider>
        <App />
      </AppConfigProvider>
    </ConfigProvider>
  );
};
